// src/components/TimelineChart.js
// Line chart: sessions/messages over time
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const TimelineChart = ({ data }) => (
  <div className="bg-white rounded-lg shadow p-6 mb-6">
    <h2 className="text-lg font-semibold mb-2">Sessions/Messages Over Time</h2>
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="day" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="count" stroke="#2563eb" name="Messages" />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

export default TimelineChart;
